<template>
  <v-card>
    <v-toolbar flat dense class="card-bar">
      <slot>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-btn icon small class="ml-2" @click="reload">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </slot>
    </v-toolbar>

    <OLoadingLine absolute :value="isLoading" />

    <ODataGrid
      class="fixed-table dense-table"
      :spec="spec"
      :data="gridData"
      :offset.sync="offset"
      :limit.sync="limit"
      rememberLastClick
      :selected="selected"
      :selectable="selectable"
      @rowClicked="showRowDetails"
    />

    <OAlert error v-if="errMessage != null">{{ errMessage }}</OAlert>
  </v-card>
</template>

<script>
import ODataGrid from 'oderon-vue/cpts/ODataGrid.vue'
import { getPref, savePref } from 'oderon-vue/Prefs'
import grid from 'oderon-commons/src/grid'

export default {
  components: { ODataGrid },
  props: {
    code: { type: String, required: true },
    title: String,
    fetcher: Function,
    spec: Object,
    selectable: { type: Boolean, default: false },
    selected: { type: Array },
    limits: { type: Array, default: () => [5, 10, 20, 50] }
  },
  data() {
    let limit = getPref(this.code + 'Limit', 5)
    return {
      isLoading: false,
      items: [],
      count: 0,
      offset: 0,
      limit,
      errMessage: null
    }
  },
  computed: {
    gridData() {
      return grid.generateWebGrid({
        rows: this.items,
        count: this.count,
        spec: this.spec
      })
    }
  },
  watch: {
    offset() {
      this.reload()
    },
    limit() {
      savePref(this.code + 'Limit', this.limit)
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reloadFromStart() {
      this.offset = 0
      this.reload()
    },

    reload() {
      this.$loadingQuiet(() => this.fetchData())
    },

    async fetchData() {
      let { limit, offset } = this
      let res = await this.fetcher({ limit, offset })
      this.items = res.rows
      this.count = res.count
    },

    showRowDetails(row, idx, evt) {
      let isMiddle = evt && (evt.ctrlKey || evt.button == 1)
      this.$emit('rowClicked', { row, idx, isMiddle })
    }
  }
}
</script>

<style></style>
